import { createFileRoute } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';
import { RESET } from 'jotai/utils';

import { abilityOverrideAtom } from '#state/atoms/ability-override-atom.js';
import { lastOpenProjectAtom } from '#state/atoms/last-open-project-atom.js';
import { clearPersistentQueryCaches } from '#utils/persistent-query-cache/persistent-query-cache.js';

export const Route = createFileRoute('/_authorization-gate/log-out/')({
	loader: async ({ context: { auth0Client, posthog } }) => {
		// Drop session-scoped state so the next login in this tab doesn't inherit the
		// previous session's org/project or ability override (sessionStorage survives
		// the Auth0 redirect within a tab).
		const store = getDefaultStore();
		store.set(lastOpenProjectAtom, RESET);
		store.set(abilityOverrideAtom, RESET);

		// Clear the PostHog identity and org group so events from a later session on
		// this machine can't attribute to the previous user or their organization.
		posthog.reset();

		try {
			await clearPersistentQueryCaches();
		} catch (error) {
			console.warn('Failed to clear persisted query cache before logout.', error);
		}

		await auth0Client.logout({
			logoutParams: {
				returnTo: window.location.origin + '/logged-out',
			},
		});

		// Stall until the redirect happens:
		await new Promise((_resolve, reject) => setTimeout(() => reject(new Error('Timed out')), 60 * 1000));
		throw new Error('Logout failed'); // Should be unreachable
	},
	pendingComponent: () => (
		<div className='grid w-full grow place-items-center'>
			<p>Logging out...</p>
		</div>
	),
});
